import { cn } from '@/lib/utils'

type SectionDividerTitleProps = {
  title: string
  className?: string
}

/** Matches BrandNameLockup typography — first word serif, remainder display. */
export function SectionDividerTitle({ title, className }: SectionDividerTitleProps) {
  const [firstWord, ...restWords] = title.split(' ')
  const rest = restWords.join(' ')

  if (!rest) {
    return (
      <h2
        className={cn(
          'max-w-[16rem] font-brand-display text-[length:var(--menu-fs-divider)] font-normal uppercase leading-none tracking-[0.14em] text-ink',
          className,
        )}
      >
        {firstWord}
      </h2>
    )
  }

  return (
    <h2 className={cn('flex max-w-[16rem] flex-col items-center gap-2 text-center leading-none', className)}>
      <span className="font-brand-serif text-[length:var(--menu-fs-divider)] font-semibold uppercase italic tracking-[0.16em] text-body">
        {firstWord}
      </span>
      <span className="font-brand-display text-[length:var(--menu-fs-divider-sub)] uppercase tracking-[0.14em] text-ink">
        {rest}
      </span>
    </h2>
  )
}
